<template>
    <div>
        <config-main-title>
            Editor de Relatório 
            <span class="badge badge-secondary small" v-if="id">#{{ id }}</span>
            <span class="badge badge-primary small" v-else>Novo</span>
        </config-main-title>

        <az-empty-state v-if="carregando" />

        <template v-else> 

            <div class="card" v-if="acesso_disponivel">
                <div class="card-header d-flex justify-content-between alert-primary">
                    <div>
                        <a class="card-link h4 mb-0" data-toggle="collapse" href="#inform-card">
                            Informações
                        </a>
                        <div class="small text-muted">{{ dados.title }}</div>
                    </div>
                    <div>
                        <button class="btn btn-outline-secondary mr-2" type="button" @click="download()" data-toggle="tooltip" data-placement="top" title="Download">
                            <i class="fas fa-download"></i>
                        </button>
                        <button class="btn btn-outline-secondary mr-2" type="button" @click="upload()" data-toggle="tooltip" data-placement="top" title="Upload">
                            <i class="fas fa-upload"></i>
                        </button>
                        <button class="btn btn-outline-secondary mr-2" type="button" @click="acessos()" v-if="dados.id">
                            <i class="fas fa-user-lock"></i>
                        </button>
                        <button class="btn btn-outline-primary" type="button" data-toggle="collapse" data-target=".multi-collapse">
                            <i class="fa-solid fa-minimize"></i>
                        </button>
                    </div>
                </div>

                <div class="card-body collapse show multi-collapse" id="inform-card">

                    <az-input 
                        label="Título"
                        placeholder="Informe o título do relatório"
                        :validate="validate"
                        required
                        v-model="dados.title" />

                    <az-input 
                        label="Descrição"
                        type="textarea"
                        rows="3"
                        :validate="validate"
                        v-model="dados.descr" />

                    <az-input
                        label="Grupo"
                        type="select"
                        optionsMode="json"
                        :optionsList="groups"
                        optionsData="id"
                        optionsDisplay="name"
                        required
                        :validate="validate"
                        v-model="dados.query_group_id" />

                    <az-input
                        v-if="!id"
                        label="Área"
                        type="select"
                        optionsMode="json"
                        :optionsList="meta"
                        optionsDisplay="name"
                        v-model="dados.meta" />

                    <az-input
                        v-else-if="dados.meta"
                        label="Área"
                        :edicao="false"
                        v-model="dados.meta.name" />

                    <az-input
                        v-if="!id"
                        label="Acesso"
                        type="select"
                        :optionsList="[
                            {id: 'M', search: 'Acessível inicialmente somente para mim'},
                            {id: 'T', search: 'Acessível inicialmente para todos os usuários'},
                        ]"
                        optionsData="id"
                        v-model="dados.acesso" />

                </div>

            </div>

            <template v-if="dados.meta">

                <!-- CAMPOS DO RELATÓRIO -->
                <div class="card" ref="campocard">

                    <div class="card-header d-flex justify-content-between alert-primary">
                        <div>
                            <a class="card-link" data-toggle="collapse" href="#campos-card">
                                Campos
                            </a>
                        </div>
                        <div>
                            <span class="badge badge-primary">
                                {{ dados.cols.length }}
                            </span>
                        </div>
                    </div>

                    <div class="card-body collapse show multi-collapse" id="campos-card">

                        <div class="mb-3" v-if="dados.cols.length == 3">
                            <az-input
                                sizing="sm"
                                type="checkbox-group"
                                label="Relatório como Tabela (Pivot)"
                                v-model="dados.pivot" />
                        </div>
        
                        <draggable v-model="dados.cols" @start="drag=true" @end="drag=false;" ghost-class="primary">

                            <div class="form-row" v-for="(campo, icx) in dados.cols" :key="'C' + icx">
                                <div class="col col-12" :class="tem_parametro_campo(campo) ? 'col-md-2' : 'col-md-3'">
                                    <az-input
                                        sizing="sm"
                                        :edicao="false"
                                        v-model="campo.name">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="removerColuna(icx)">
                                                    <i class="fa-solid fa-minus"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>

                                <div class="col col-12 col-md-1" v-if="tem_parametro_campo(campo)">
                                    <template v-if="campo.params && campo.params.length > 0">
                                        <az-input
                                            v-for="(param, ipx) in campo.params" 
                                            :key="ipx"
                                            sizing="sm"
                                            :placeholder="param + '...'"
                                            v-model="campo['parm_campo_' + ipx]" />
                                    </template>
                                    <template v-else>
                                        <az-input
                                            sizing="sm"
                                            :placeholder="tem_parametro_campo(campo, '[?]') ? 'Id...' : 'Parâmetro...'"
                                            v-model="campo.parm_campo" />
                                    </template>
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        placeholder="Título..."
                                        :validate="validate"
                                        v-model="campo.title">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <div class="input-group-text">
                                                    <small>#{{ icx + 1 }}</small>
                                                </div>
                                                <button type="button" class="btn btn-outline-secondary" @click="toggle_hide(campo)" v-if="campo.action != 'X' && campo.action != 'Q' && campo.action != 'P'">
                                                    <i class="fa-solid fa-eye fa-fw" v-if="!campo.hide" title="Campo exibido."></i>
                                                    <i class="fa-solid fa-eye-slash fa-fw" v-else title="Campo ocultado."></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>

                                <div class="col col-12 col-md-2">

                                    <!-- Campo Tipo Fórmula -->
                                    <az-input
                                        sizing="sm"
                                        v-if="campo.value == 'computed'"
                                        placeholder="Fórmula... (Ex: #1 * 2)"
                                        v-model="campo.compute" />

                                    <!-- Campo Tipo Categoria -->
                                    <az-input
                                        sizing="sm"
                                        type="select"
                                        v-if="campo.value == 'category' || campo.value == 'timestamp'"
                                        optionsMode="json"
                                        :optionsList="[
                                            {id: 'L', search: 'Listar'},
                                            {id: 'Q', search: 'Agrupar'},
                                            {id: 'C', search: 'Contar'},
                                            {id: 'D', search: 'Contar Distintos'},
                                            {id: 'P', search: 'Coluna (Pivot)'},
                                            {id: 'T', search: 'Máximo'},
                                            {id: 'B', search: 'Mínimo'},
                                            {id: 'X', search: 'Dimensão'},
                                            {id: 'N', search: 'Número'},
                                            {id: 'G', search: 'Listar Coluna'},
                                        ]"
                                        optionsDisplay="search"
                                        optionsData="id"
                                        v-model="campo.action">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append input-group-sm">
                                                <input type="text" class="form form-control" v-model="campo.grp" placeholder="Quebra..." v-if="campo.action == 'Q'"
                                                    style="max-width: 70pt;" />
                                            </div>
                                        </template>
                                    </az-input>

                                    <!-- Campo Tipo Valor -->
                                    <az-input
                                        sizing="sm"
                                        type="select"
                                        v-if="campo.value == 'value'"
                                        optionsMode="json"
                                        :optionsList="[
                                            {id: 'L', search: 'Listar'},
                                            {id: 'Q', search: 'Agrupar'},
                                            {id: 'S', search: 'Somar'},
                                            {id: 'M', search: 'Média'},
                                            {id: 'T', search: 'Máximo'},
                                            {id: 'B', search: 'Mínimo'},
                                        ]"
                                        optionsDisplay="search"
                                        optionsData="id"
                                        v-model="campo.action">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append input-group-sm">
                                                <input type="text" class="form form-control" v-model="campo.grp" placeholder="Quebra..." v-if="campo.action == 'Q'"
                                                    style="max-width: 70pt;" />
                                            </div>
                                        </template>
                                    </az-input>

                                </div>

                                <div class="col col-12 col-md-4">

                                    <!-- Campo Tipo Data -->
                                    <div class="form-row">
                                        <div class="col col-12 col-md-6" v-if="!( campo.value == 'computed' || campo.value == 'value' || campo.action == 'C' || campo.action == 'D') && tem_agregacao"> 
                                            <az-input
                                                sizing="sm"
                                                type="checkbox-group"
                                                label="Ocultar Sintético"
                                                :edicao="campo.action != 'P'"
                                                v-model="campo.ocultar_sintetico" />
                                        </div>

                                        <!-- Campo Tipo Data -->
                                        <div class="col col-12 col-md-6" v-if="campo.value == 'timestamp'">
                                            <az-input
                                                sizing="sm"
                                                type="select"
                                                v-if="campo.value == 'timestamp'"
                                                optionsMode="json"
                                                :optionsList="[
                                                    {id: 'dt', search: 'Data/Hora'},
                                                    {id: 'd', search: 'Data'},
                                                    {id: 'm', search: 'Mês'},
                                                    {id: 'y', search: 'Ano'},
                                                    {id: 'w', search: 'Semana (1-53)'},
                                                    {id: 'wd', search: 'Dia da Semana'},
                                                    {id: 'dm', search: 'Dia do Mês'},
                                                    {id: 'H', search: 'Hora'},
                                                    {id: 'Hi', search: 'Hora/Minuto'},
                                                    {id: 'a', search: 'am/pm (manhã/tarde)'},
                                                ]"
                                                optionsDisplay="search"
                                                optionsData="id"
                                                v-model="campo.format" />
                                        </div>
                                    </div>

                                    <!-- Totalizar -->
                                    <template v-if="campo.value == 'computed' || campo.value == 'value' || campo.action == 'C' || campo.action == 'D'">
                                        <div class="form-row">
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    sizing="sm"
                                                    type="checkbox-group"
                                                    label="Totalizar"
                                                    v-model="campo.totalizar" />
                                            </div>
                                            <div class="col col-12" :class="campo.value == 'computed' ? 'col-md-3' : 'col-md-3'" v-if="campo.totalizar">
                                                <az-input
                                                        sizing="sm"
                                                        type="checkbox-group"
                                                        label="Perc"
                                                        v-model="campo.percent" />
                                            </div>
                                            <div class="col col-12 col-md-3" v-if="campo.totalizar"> <!--  && campo.value != 'computed' -->
                                                <az-input
                                                    sizing="sm"
                                                    type="checkbox-group"
                                                    label="Média"
                                                    v-model="campo.avg" />
                                            </div>
                                            <div class="col col-12" :class="campo.totalizar ? 'col-md-3' : 'col-md-6'" v-if="( campo.value == 'computed' ) || ( campo.c_id )">
                                                <az-input
                                                    sizing="sm"
                                                    type="select"
                                                    :optionsList="[
                                                        {id: false, search: 'Número'},
                                                        {id: true, search: 'Moeda'},
                                                        {id: 'T', search: 'Texto'},
                                                        {id: 'B', search: 'Cód. Barras'},
                                                        {id: 'D', search: 'Data'},
                                                        {id: 'DH', search: 'Data/Hora'},
                                                    ]"
                                                    optionsData="id"
                                                    optionsDisplay="search"
                                                    placeholder="Formatação..."
                                                    v-model="campo.fm" />
                                                <az-input
                                                    v-if="false"
                                                    sizing="sm"
                                                    type="checkbox-group"
                                                    label="Moeda"
                                                    v-model="campo.fm" />
                                            </div>
                                        </div>
                                    </template>

                                    <!-- Totalizar -->
                                    <az-input
                                        v-else-if="1==0 && tem_agregacao"
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Ocultar Sintético"
                                        v-model="campo.ocultar_sintetico" />

                                </div>

                            </div>

                        </draggable>

                        <az-input
                            sizing="sm"
                            icon="fa fa-plus"
                            type="select"
                            optionsMode="json"
                            :optionsList="lista_campos"
                            optionsDisplay="title"
                            v-model="novocampo" 
                            @input="incluir_campo()">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" title="Incluir Campo Calculado" @click="incluir_campo(true)">
                                        <i class="fa-solid fa-calculator"></i>
                                    </button>
                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="abrir_lista_selecao(lista_campos, callback_campo)" v-shortkey="['ctrl', 'q']" @shortkey="abrir_lista_selecao(lista_campos, callback_campo, 'campocard')" title="Incluir Campo (CONTROL+Q)">
                                        <i class="fa fa-search fa-fw" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>

                </div>

                <!-- FILTROS -->

                <div class="card" ref="filtrocard">

                    <div class="card-header d-flex justify-content-between alert-primary">
                        <a class="card-link" data-toggle="collapse" href="#filtros-card">
                            Filtros    
                        </a>
                        <div>
                            <span class="badge badge-primary">
                                {{ dados.filtros.length }}
                            </span>
                        </div>
                    </div>

                    <div class="card-body collapse show multi-collapse" id="filtros-card">

                        <draggable v-model="dados.filtros" @start="drag=true" @end="drag=false;" ghost-class="primary">

                            <div class="form-row" v-for="(filtro, icx) in dados.filtros" :key="'F' + icx">
                                <div class="col col-12" :class="tem_parametro_campo(filtro) ? 'col-md-2' : 'col-md-3'">
                                    <az-input
                                        :buttonIcon="true" 
                                        buttonText="fas fa-minus" 
                                        buttonColor="outline-danger"
                                        @clickButton="removerFiltro(icx)"
                                        sizing="sm"
                                        icon="fa fa-minus"
                                        :edicao="false"
                                        v-model="filtro.name" />
                                </div>

                                <div class="col col-12 col-md-1" v-if="tem_parametro_campo(filtro)">
                                    <az-input
                                        sizing="sm"
                                        placeholder="Parâmetro..."
                                        v-model="filtro.parm_campo" />
                                </div>

                                <div class="col col-12" :class="filtro_agregado(filtro) ? 'col-md-2' : 'col-md-3'">
                                    <az-input
                                        sizing="sm"
                                        type="select"
                                        optionsMode="json"
                                        :optionsList="lista_tipo_filtro(filtro)"
                                        optionsDisplay="search"
                                        optionsData="id"
                                        v-model="filtro.tipo" />
                                </div>

                                <div v-if="filtro_agregado(filtro)" class="col col-12 col-md-1">
                                    <az-input
                                        sizing="sm"
                                        type="select"
                                        optionsMode="json"
                                        :optionsList="[
                                            { id: 'S', search: 'Agregado' },
                                            { id: 'N', search: 'Individual' },
                                        ]"
                                        optionsDisplay="search"
                                        optionsData="id"
                                        v-model="filtro.having" />
                                </div>

                                <template v-if="filtro.tipo != 'U' && filtro.tipo != 'M' && filtro.tipo != 'A'">

                                    <div class="col col-12 col-md-2">
                                        <az-input
                                            v-if="filtro.value == 'timestamp'"
                                            sizing="sm"
                                            :edicao="false"
                                            placeholder="Período" />

                                        <az-input
                                            v-else-if="filtro.value == 'category' && filtro.type == 'boolean'"
                                            sizing="sm"
                                            placeholder="Apenas"
                                            :edicao="false" />

                                        <az-input
                                            v-else-if="filtro.value == 'value' || filtro.value == 'computed'"
                                            sizing="sm"
                                            type="select"
                                            optionsMode="json"
                                            :optionsList="[
                                                {id: '=', search: 'Apenas'},
                                                {id: '<>', search: 'Exceto'},
                                                {id: '>', search: 'Maior Que'},
                                                {id: '>=', search: 'Maior ou Igual a'},
                                                {id: '<', search: 'Menor Que'},
                                                {id: '<=', search: 'Menor ou Igual a'},
                                                {id: 'faixa', search: 'Faixa'},
                                            ]"
                                            optionsDisplay="search"
                                            optionsData="id"
                                            v-model="filtro.operacao" />

                                        <az-input
                                            v-else-if="filtro.type == 'json'"
                                            sizing="sm"
                                            type="select"
                                            optionsMode="json"
                                            :optionsList="[
                                                {id: '=', search: 'Apenas'},
                                                {id: '<>', search: 'Exceto'},
                                            ]"
                                            optionsDisplay="search"
                                            optionsData="id"
                                            v-model="filtro.operacao" />

                                        <az-input
                                            v-else
                                            sizing="sm"
                                            type="select"
                                            optionsMode="json"
                                            :optionsList="
                                                filtro.type == 'string' 
                                                    ? 
                                                        [
                                                            {id: '=', search: 'Apenas'},
                                                            {id: '<>', search: 'Exceto'},
                                                            {id: 'like', search: 'Contem'},
                                                            {id: 'not like', search: 'Não Contem'},
                                                            {id: 'p', search: 'Preenchido'},
                                                            {id: 'np', search: 'Não Preenchido'},
                                                        ]
                                                    : ( filtro.type == 'number'
                                                        ? [
                                                            {id: '=', search: 'Apenas'},
                                                            {id: '<>', search: 'Exceto'},
                                                            {id: 'p', search: 'Preenchido'},
                                                            {id: 'np', search: 'Não Preenchido'},
                                                            {id: '>', search: 'Maior Que'},
                                                            {id: '>=', search: 'Maior ou Igual a'},
                                                            {id: '<', search: 'Menor Que'},
                                                            {id: '<=', search: 'Menor ou Igual a'},
                                                            {id: 'faixa', search: 'Faixa'},
                                                        ]
                                                        :  
                                                            [
                                                                {id: '=', search: 'Apenas'},
                                                                {id: '<>', search: 'Exceto'},
                                                                {id: 'p', search: 'Preenchido'},
                                                                {id: 'np', search: 'Não Preenchido'},
                                                            ]
                                                    )
                                                "
                                            optionsDisplay="search"
                                            optionsData="id"
                                            v-model="filtro.operacao" />

                                    </div>

                                    <!-- Opçoes -->
                                    <div class="col col-12 col-md-4" v-if="!filtro.operacao || ( filtro.operacao != 'p' && filtro.operacao != 'np' )">
                                        <az-input 
                                            v-if="filtro.value == 'timestamp'"
                                            type="select"
                                            optionsMode="json"
                                            :optionsList="[
                                                {id: 'l', search: 'Nenhum'},
                                                {id: 'm', search: 'Mês Atual'},
                                                {id: 'ma', search: 'Mês Anterior'},
                                                {id: 'a', search: 'Ano Atual'},
                                                {id: 'aa', search: 'Ano Anterior'},
                                                {id: 'h', search: 'Hoje'},
                                                {id: 'o', search: 'Ontem'},
                                                {id: 'do', search: 'Desde Ontem'},
                                                {id: 't', search: 'Amanhã'},
                                                {id: 's', search: 'Essa Semana'},
                                                {id: 'u3', search: 'Últimos 30 dias'},
                                                {id: 'u6', search: 'Últimos 60 dias'},
                                                {id: 'u9', search: 'Últimos 90 dias'},
                                            ]"
                                            optionsDisplay="search"
                                            optionsData="id"
                                            sizing="sm"
                                            v-model="filtro.valor" />

                                        <az-input 
                                            v-else-if="filtro.value == 'category' && filtro.type == 'boolean'"
                                            type="select"
                                            optionsMode="json"
                                            :optionsList="[
                                                {id: 'S', search: 'Sim'},
                                                {id: 'N', search: 'Não'},
                                            ]"
                                            optionsDisplay="search"
                                            optionsData="id"
                                            sizing="sm"
                                            v-model="filtro.valor" />

                                        <az-input 
                                            v-else-if="trocando_tipo !== icx && filtro.value == 'category' && ( filtro.operacao == '=' || filtro.operacao == '<>' ) && filtro.service && filtro.format != 'list-sql'"
                                            placeholder="Selecione..."
                                            sizing="sm"
                                            :type="filtro.list ? 'text' : ( filtro.dd ? 'select' : 'autocomplete' )"  
                                            optionsMode="aql"
                                            :service="get_service(filtro)" 
                                            :optionsName="'r-filtro-' + get_service(filtro)"
                                            :optionsParm="{ ativos: true, agenda: true, azi: 1 }"
                                            :optionsData="filtro.format == 'list-tags' ? 'id' : filtro.data"
                                            required 
                                            v-model="filtro.valor">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="filtro.data">
                                                    <button v-if="false" type="button" class="btn" :class="filtro.list ? 'btn-primary' : 'btn-outline-primary'" :title="filtro.list ? 'Lista' : 'Item'" @click="toggle_lista(filtro, icx)">
                                                        <i class="fa-solid fa-list-check fa-fw"></i>
                                                    </button>    

                                                    <button type="button" class="btn btn-outline-primary" 
                                                        v-if="filtro.service != 'medico_solicitantes.index'"
                                                        :title="filtro.dd ? 'Dropdown (Lista)' : 'Busca (Autocompletar)'" @click="toggle_select_type(filtro, icx)">
                                                        <i class="fa-regular fa-square-caret-down fa-fw" v-if="filtro.dd"></i>
                                                        <i class="fa-solid fa-magnifying-glass fa-fw" v-else></i>
                                                    </button>
                                                </div>
                                            </template>
                                        </az-input>

                                        <az-input 
                                            v-else-if="filtro.value == 'category' && ( filtro.operacao == '=' || filtro.operacao == '<>' ) && ( ( filtro.options && filtro.options.length ) || filtro.format == 'list-sql' )"
                                            placeholder="Selecione..."
                                            sizing="sm"
                                            type="select" 
                                            optionsMode="json"
                                            optionsData="id"
                                            optionsDisplay="search"
                                            :optionsList="tratar_opcoes(filtro.options, filtro)"
                                            required 
                                            v-model="filtro.valor" />

                                        <az-input 
                                            v-else-if="filtro.value == 'value' && filtro.operacao == 'faixa'"
                                            sizing="sm" 
                                            type="number"
                                            placeholder="De..."
                                            :validate="validate"
                                            v-model="filtro.valor">
                                            <template v-slot:buttonposb>
                                                <input type="number" class="form form-control" v-model="filtro.valor_ate" placeholder="Até...">
                                            </template>
                                        </az-input>

                                        <az-input 
                                            v-else
                                            sizing="sm" 
                                            :validate="validate"
                                            v-model="filtro.valor" />

                                    </div>

                                    <template v-if="false && ( !filtro.operacao || ( filtro.operacao != 'p' && filtro.operacao != 'np' ) ) && filtro.value == 'timestamp' && filtro.valor == 'l'">
                                        <div class="col col-12 offset-md-8 col-md-2">
                                            <az-input
                                                icon="fa-solid fa-greater-than-equal"
                                                sizing="sm"
                                                type="date"
                                                v-model="filtro.inicio" />
                                        </div>
                                        <div class="col col-12 col-md-2">
                                            <az-input
                                                icon="fa-solid fa-less-than-equal"
                                                sizing="sm"
                                                type="date"
                                                v-model="filtro.fim" />
                                        </div>
                                    </template>

                                </template>

                            </div>

                        </draggable>

                        <az-input
                            sizing="sm"
                            icon="fa fa-plus"
                            type="select"
                            optionsMode="json"
                            :optionsList="lista_campos"
                            optionsDisplay="title"
                            v-model="novofiltro" 
                            @input="incluir_filtro()">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary" type="button" id="button-addon2" title="Incluir Filtro (CONTROL+W)" @click="abrir_lista_selecao(lista_campos, callback_filtro)" v-shortkey="['ctrl', 'w']" @shortkey="abrir_lista_selecao(lista_campos, callback_filtro, 'filtrocard')">
                                        <i class="fa fa-search fa-fw" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>

                    </div>

                </div>

                <!-- Ordenação -->

                <div class="card">

                    <div class="card-header d-flex justify-content-between alert-primary">
                        <a class="card-link" data-toggle="collapse" href="#ordem-card">
                            Ordenação
                        </a>
                        <div>
                            <span class="badge badge-primary">
                                {{ dados.ordem ? dados.ordem.length : 0 }}
                            </span>
                        </div>
                    </div>

                    <div class="card-body collapse show multi-collapse" id="ordem-card">

                        <template v-if="dados.ordem">

                            <div class="form-row" v-for="(ordem, icx) in dados.ordem" :key="'O' + icx">
                                <div class="col col-12 col-md-3">
                                    <az-input
                                        sizing="sm"
                                        placeholder="Ordem..."
                                        required
                                        :validate="validate"
                                        v-model="ordem.direc" 
                                        type="select"
                                        optionsMode="json"
                                        :optionsList="[
                                            { id: 'ASC', search: 'Crescente' },                                        
                                            { id: 'DESC', search: 'Decrescente' },  
                                        ]" 
                                        optionsDisplay="search"
                                        optionsData="id">
                                        
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="removerOrdem(icx)">
                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>

                                <div class="col col-12 col-md-3">
                                    <div class="input-group input-group-sm">
                                        <input class="form form-control" disabled :value="( dados.cols && dados.cols.length > ordem.index ) ? dados.cols[ordem.index].title : ordem.index" />
                                    </div>
                                </div>

                            </div>

                        </template>

                        <az-input
                            sizing="sm"
                            icon="fa fa-plus"
                            type="select"
                            optionsMode="json"
                            :optionsList="dados.cols"
                            optionsDisplay="title"
                            v-model="novaordem" 
                            @input="incluir_ordem()" />

                    </div>

                </div>

                <!-- Informação Complementar -->

                <div class="card">

                    <div class="card-header d-flex justify-content-between alert-primary">
                        <div>
                            <a class="card-link" data-toggle="collapse" href="#comp-card">
                                Informação Complementar
                            </a>
                        </div>
                        <div>
                            <span class="badge badge-primary">
                                {{ dados.comps ? dados.comps.length : 0 }}
                            </span>
                        </div>   
                    </div>

                    <div class="collapse show multi-collapse" id="comp-card">

                        <div class="card-body">

                            <div v-if="!dados.comps || !dados.comps.length">Nenhuma informação complementar registrada. Utilize esse recurso para unir dados de outro relatório.</div>

                            <template v-else>
                                <div v-for="(comp, igx) in dados.comps" :key="'gr' + igx">
                                    <div class="form-row">
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                sizing="sm"
                                                placeholder="Selecione..."
                                                required
                                                :validate="validate"
                                                v-model="comp.type" 
                                                type="select"
                                                edicao2="!comp.query_id"
                                                optionsMode="json"
                                                :optionsList="[
                                                    { id: 'union', search: 'União de Dados (Junção das linhas dos relatórios)' },                                        
                                                    { id: 'procv', search: 'Preenchimento de Coluna(s) (PROCV) por Filtros ' },  
                                                    { id: 'procv1', search: 'Preenchimento de Coluna(s) (PROCV) por Id' },  
                                                    { id: 'exists', search: 'Verificação de Existência de Correlação por Filtros' },  
                                                    { id: 'exists1', search: 'Verificação de Existência de Correlação por Id' },  
                                                    { id: 'notexists', search: 'Verificação de não Existência de Correlação por Filtros' },  
                                                    { id: 'notexists1', search: 'Verificação de não Existência de Correlação por Id' },  
                                                ]" 
                                                optionsDisplay="search"
                                                optionsData="id">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="removerComp(igx)">
                                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-6" v-if="comp.type">
                                            <az-input
                                                sizing="sm"
                                                type="select"
                                                placeholder="Selecione o Relatório Complementar..."
                                                :optionsList="relatorios"
                                                optionsData="id"
                                                optionsDisplay="title"
                                                required
                                                :validate="validate"
                                                :edicao="( !comp.parms || !comp.parms.length ) && ( !comp.links || !comp.links.length )"
                                                v-model="comp.query_id">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append">
                                                        <div class="input-group-text" v-if="comp.query_id">
                                                            {{ comp.query_id }}
                                                        </div>
                                                        <button class="btn btn-outline-secondary" type="button" id="button-addon2" title="Editar Relatório" @click="editar_relatorio(comp.query_id)" v-if="comp.query_id">
                                                            <i class="fa-solid fa-pencil"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                    </div>

                                    <div class="mt-2" v-if="comp.type == 'union' && !comp.query_id">
                                        <i class="fa-solid fa-circle-info text-primary mr-2"></i>
                                        <ul class="small text-muted">
                                            <li>
                                                O relatório complementar deve possuir a mesma estrutura de colunas do relatório principal, para que a união dos dados seja realizada corretamente, mesmo que os relatórios sejam de origem de áreas diferentes.
                                            </li>
                                            <li>
                                                As colunas não precisam ser exatamente dos mesmos campos, mas devem ser relacionadas, pois esse processo equivale a união de listas.
                                            </li>
                                            <li>
                                                Após a união dos dados, eles são re-ordenados conforme critério definido no relatório principal.
                                            </li>
                                            <li>
                                                Caso um dos relatórios tenha uma ou mais colunas a mais, podem ser criados campos fórmula vazios no outro relatório, para realizar a equivalência entre as colunas.
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="mt-2" v-else-if="( comp.type == 'procv' || comp.type == 'procv1' ) && !comp.query_id">
                                        <i class="fa-solid fa-circle-info text-primary mr-2"></i>
                                        <ul class="small text-muted">
                                            <li>
                                                Operação para preenchimento de uma ou mais colunas do relatório principal, a partir de dados do relatório complementar.
                                            </li>
                                            <li>
                                                Para que sejam posicionados os campos no relatório principal, devem ser criados campos fórmula (com valor vazio) para receber os dados do relatório complementar.
                                            </li>
                                            <li v-if="( comp.type.slice(-1) == '1' )">
                                                Ao selecionar a opção "Por Id", o pareamento de filtros será realizado utilizando um campo de identificação (ID) presente nos registros do relatório principal, sendo que o relatório complementar deve ter um filtro por esse campo Id.
                                            </li>
                                            <li v-else>
                                                Após a seleção do relatório complementar, serão realizados os pareamentos dos filtros entre os relatórios e as correlações de dados para preenchimento da(s) coluna(s).
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="mt-2" v-else-if="( comp.type == 'exists' || comp.type == 'exists1' ) && !comp.query_id">
                                        <i class="fa-solid fa-circle-info text-primary mr-2"></i>
                                        <ul class="small text-muted">
                                            <li>
                                                Recurso para filtragem de linhas do relatório principal, a partir da existência de correlação com o relatório complementar.
                                            </li>
                                            <li v-if="( comp.type.slice(-1) == '1' )">
                                                Ao selecionar a opção "Por Id", o pareamento de filtros será realizado utilizando um campo de identificação (ID) presente nos registros do relatório principal, sendo que o relatório complementar deve ter um filtro por esse campo Id.
                                            </li>
                                        </ul>
                                    </div>

                                    <div class="mt-2" v-else-if="( comp.type == 'notexists' || comp.type == 'notexists1' ) && !comp.query_id">
                                        <i class="fa-solid fa-circle-info text-primary mr-2"></i>
                                        <ul class="small text-muted">
                                            <li>
                                                Recurso para filtragem de linhas do relatório principal, a partir da não existência de correlação com o relatório complementar.
                                            </li>
                                            <li v-if="( comp.type.slice(-1) == '1' )">
                                                Ao selecionar a opção "Por Id", o pareamento de filtros será realizado utilizando um campo de identificação (ID) presente nos registros do relatório principal, sendo que o relatório complementar deve ter um filtro por esse campo Id.
                                            </li>
                                        </ul>
                                    </div>

                                    <!-- Pareamento de Filtros -->

                                    <div class="mt-2" v-if="comp.query_id">
                                        <div class="card">
                                            <div class="card-header d-flex justify-content-between">
                                                <div>
                                                    Pareamento de Filtros
                                                </div>
                                                <button type="button" class="btn btn-sm btn-outline-primary" @click="incluir_parm(comp)" :disabled=" ( comp.type.slice(-1) == '1' ) && comp.parms && ( comp.parms.length > 0 )">
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                            <div class="card-body">
                                                <div v-if="comp.parms && !comp.parms.length">
                                                    <i class="fa fa-exclamation-triangle text-warning mr-3" aria-hidden="true"></i>
                                                    Não informado.

                                                    <div class="mt-3 small text-muted" v-if="( comp.type.slice(-1) == '1' )">
                                                        Ao selecionar a opção "Por Id", o pareamento de filtros será realizado utilizando o campo de identificação (ID) dos registros, sendo que o relatório relacionado deve ter um filtro por esse campo Id.
                                                    </div>

                                                    <div class="mt-3 small text-muted" v-else>
                                                        Relacione os filtros entre os dois relatórios.
                                                    </div>
                                                </div>
                                                <div class="form-row" v-for="(parm, ilx) in comp.parms" :key="ilx">
                                                    <div class="col col-12 col-md-5">
                                                        <az-input
                                                            v-if="comp.type.slice(-1) == '1'"
                                                            :label="!ilx ? dados.title : ''"
                                                            sizing="sm"
                                                            placeholder="Selecione o Filtro do Relatório Principal..."
                                                            required
                                                            :validate="validate"
                                                            type="select"
                                                            :optionsList="dados.cols.filter(col => col.value == 'category' && col.type == 'number')"
                                                            optionsDisplay="name"
                                                            optionsData="column_name"
                                                            v-model="parm.de">
                                                            <template v-slot:button-pre>
                                                                <div class="input-group-prepend">
                                                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="comp.parms.splice(ilx, 1)">
                                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                                    </button>
                                                                </div>
                                                            </template>
                                                        </az-input>

                                                        <az-input
                                                            v-else
                                                            :label="!ilx ? dados.title : ''"
                                                            sizing="sm"
                                                            placeholder="Selecione o Filtro do Relatório Principal..."
                                                            required
                                                            :validate="validate"
                                                            type="select"
                                                            :optionsList="comp_filtros" 
                                                            optionsDisplay="search"
                                                            optionsData="chave"
                                                            v-model="parm.de">
                                                            <template v-slot:button-pre>
                                                                <div class="input-group-prepend">
                                                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="comp.parms.splice(ilx, 1)">
                                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                                    </button>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>
                                                    <div class="col col-12 col-md-7">
                                                        <az-input
                                                            sizing="sm"
                                                            :label="!ilx ? sel_query_title(comp.query_id) : ''"
                                                            placeholder="Selecione o Filtro do Relatório Complementar..."
                                                            required
                                                            :validate="validate"
                                                            type="select"
                                                            :optionsList="sel_query_parms(comp.query_id)" 
                                                            optionsDisplay="title"
                                                            optionsData="id"
                                                            v-model="parm.para" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="card" v-if="( comp.type != 'union' ) && comp.links">
                                            <div class="card-header d-flex justify-content-between">
                                                <div>
                                                    Correlação de Dados
                                                </div>
                                                <div>
                                                    <button type="button" class="btn btn-sm btn-outline-primary" @click="incluir_link(comp)">
                                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div v-if="comp.links && !comp.links.length">
                                                    <i class="fa fa-exclamation-triangle text-warning mr-3" aria-hidden="true"></i>
                                                    Não informado.

                                                    <div class="mt-3 small text-muted">
                                                        Relacione os campos que serão utilizados para correlação dos dados entre os relatórios.
                                                    </div>
                                                </div>
                                                <div class="form-row" v-for="(link, ilx) in comp.links" :key="ilx">
                                                    <div class="col col-12 col-md-5">
                                                        <az-input
                                                            sizing="sm"
                                                            :label="!ilx ? dados.title : ''"
                                                            placeholder="Selecione Coluna do Relatório Principal..."
                                                            required
                                                            :validate="validate"
                                                            type="select"
                                                            :optionsList="dados.cols" 
                                                            optionsDisplay="name"
                                                            optionsData="column_name"
                                                            v-model="link.de">
                                                            <template v-slot:button-pre>
                                                                <div class="input-group-prepend">
                                                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="comp.links.splice(ilx, 1)">
                                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                                    </button>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>
                                                    <div class="col col-12 col-md-2">
                                                        <az-input
                                                            :label="!ilx ? 'Relação' : ''"
                                                            sizing="sm"
                                                            placeholder="Selecione..."
                                                            required
                                                            :validate="validate"
                                                            type="select"
                                                            :optionsList="[
                                                                { id: '=', name: 'Igual' },
                                                                { id: '<>', name: 'Diferente' },
                                                                { id: '>', name: 'Maior' },
                                                                { id: '>=', name: 'Maior ou Igual' },
                                                                { id: '<', name: 'Menor' },
                                                                { id: '<=', name: 'Menor ou Igual' },
                                                            ]" 
                                                            optionsDisplay="name"
                                                            optionsData="id"
                                                            v-model="link.oper" />
                                                    </div>
                                                    <div class="col col-12 col-md-5">
                                                        <az-input
                                                            :label="!ilx ? sel_query_title(comp.query_id) : ''"
                                                            sizing="sm"
                                                            placeholder="Selecione Coluna do Relatório Complementar..."
                                                            required
                                                            :validate="validate"
                                                            type="select"
                                                            :optionsList="sel_query_campos(comp.query_id)" 
                                                            optionsDisplay="name"
                                                            optionsData="column_name"
                                                            v-model="link.para" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" v-if="( comp.type == 'procv' || comp.type == 'procv1' ) && comp.fills">
                                            <div class="card-header d-flex justify-content-between">
                                                <div>
                                                    Preenchimento de Valores
                                                </div>
                                                <button type="button" class="btn btn-sm btn-outline-primary" @click="incluir_fill(comp)">
                                                    <i class="fa fa-plus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                            <div class="card-body">
                                                <div v-if="comp.fills && !comp.fills.length">
                                                    <i class="fa fa-exclamation-triangle text-warning mr-3" aria-hidden="true"></i>
                                                    Não informado.

                                                    <div class="mt-3 small text-muted">
                                                        Para o preenchimento de colunas, devem ser acrescentadas colunas tipo fórmula (com valor vazio) para receber o valor do relatório relacionado.
                                                    </div>
                                                </div>
                                                <div class="form-row" v-for="(fill, ilx) in comp.fills" :key="ilx">
                                                    <div class="col col-12 col-md-5">
                                                        <az-input
                                                            sizing="sm"
                                                            placeholder="Preencher Coluna..."
                                                            :label="!ilx ? dados.title : ''"
                                                            :validate="validate"
                                                            type="select"
                                                            :optionsList="dados.cols.filter(col => col.formula)" 
                                                            optionsDisplay="name"
                                                            optionsData="column_name"
                                                            v-model="fill.campo">
                                                            <template v-slot:button-pre>
                                                                <div class="input-group-prepend">
                                                                    <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="comp.fills.splice(ilx, 1)">
                                                                        <i class="fa fa-minus" aria-hidden="true"></i>
                                                                    </button>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>
                                                    <div class="col col-12 col-md-5">
                                                        <az-input
                                                            :label="!ilx ? sel_query_title(comp.query_id) : ''"
                                                            sizing="sm"
                                                            placeholder="A partir de..."
                                                            :validate="validate"
                                                            type="select"
                                                            :optionsList="sel_query_campos(comp.query_id)" 
                                                            optionsDisplay="name"
                                                            optionsData="column_name"
                                                            v-model="fill.fonte">
                                                            <template v-slot:button-pre>
                                                                <div class="input-group-prepend">
                                                                    <div class="input-group-text">
                                                                        <i class="fa-solid fa-equals"></i>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </az-input>
                                                    </div>
                                                    <div class="col col-12 col-md-2">
                                                        <az-input
                                                            :label="!ilx ? 'Ação' : ''"
                                                            sizing="sm"
                                                            placeholder="Selecione..."
                                                            :validate="validate"
                                                            type="select"
                                                            :optionsList="
                                                                [
                                                                    { id: 'L', name: 'Listar' },
                                                                    { id: 'D', name: 'Distintos' }, 
                                                                    { id: 'S', name: 'Somar' }, 
                                                                ]
                                                            " 
                                                            optionsDisplay="name"
                                                            optionsData="id"
                                                            v-model="fill.oper">
                                                        </az-input>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr>
                                </div>
                            </template>
                        </div>

                        <div class="card-footer">
                            <a class="btn btn-sm btn-outline-primary" href="#" @click.prevent="incluir_comp()">
                                <i class="fas fa-plus"></i>
                            </a> 
                        </div>
                    </div>
                </div>


                <!-- GRÁFICOS -->

                <div class="card">

                    <div class="card-header d-flex justify-content-between alert-primary">
                        <div>
                            <a class="card-link" data-toggle="collapse" href="#graph-card">
                                Gráficos
                            </a>
                        </div>
                        <div>
                            <span class="badge badge-primary">
                                {{ dados.graphs ? dados.graphs.length : 0 }}
                            </span>
                        </div>
                    </div>

                    <div class="collapse show multi-collapse" id="graph-card">

                        <div class="card-body">

                            <div v-if="!dados.graphs.length">Nenhum gráfico incluído.</div>

                            <table class="table table-sm" v-else>
                                <thead>
                                    <tr>
                                        <th>Título</th>
                                        <th>Tipo</th>
                                        <th>Variável</th>
                                        <th>Categoria</th>
                                        <th>Ordem</th>
                                        <th>Amostras</th>
                                        <th>Série</th>
                                        <th>Largura</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(graph, igx) in dados.graphs" :key="'gr' + igx">
                                        <td>
                                            <az-input
                                                sizing="sm"
                                                placeholder="Título..."
                                                :validate="validate"
                                                v-model="graph.title">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="removerGrafico(igx)">
                                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>

                                            </az-input>
                                        </td>
                                        <td>
                                            <az-input
                                                sizing="sm"
                                                placeholder="Tipo..."
                                                required
                                                :validate="validate"
                                                v-model="graph.type" 
                                                type="select"
                                                optionsMode="json"
                                                :optionsList="[
                                                    { id: 'line', search: 'Linha' },                                        
                                                    { id: 'bar', search: 'Barra' },  
                                                    { id: 'horizontalBar', search: 'Barra Horizontal' },
                                                    { id: 'pie', search: 'Pizza' },
                                                ]" 
                                                optionsDisplay="search"
                                                optionsData="id" />
                                        </td>
                                        <td>
                                            <az-input
                                                sizing="sm"
                                                placeholder="Variável..."
                                                required
                                                :validate="validate"
                                                v-model="graph.c_var" 
                                                type="select"
                                                optionsMode="json"
                                                :optionsList="lista_variaveis" 
                                                optionsDisplay="search"
                                                optionsData="id" />
                                        </td>
                                        <td>
                                            <az-input
                                                sizing="sm"
                                                placeholder="Categoria..."
                                                required
                                                :validate="validate"
                                                v-model="graph.c_category" 
                                                type="select"
                                                optionsMode="json"
                                                :optionsList="lista_categorias" 
                                                optionsDisplay="search"
                                                optionsData="id" />
                                        </td>
                                        <td>
                                            <az-input
                                                sizing="sm"
                                                placeholder="Ordem..."
                                                required
                                                :validate="validate"
                                                v-model="graph.ordem" 
                                                type="select"
                                                optionsMode="json"
                                                :optionsList="[
                                                    { id: 'none', search: 'Padrão' },
                                                    { id: 'value', search: 'Valor' },
                                                    { id: 'category', search: 'Categoria' },
                                                ]" 
                                                optionsDisplay="search"
                                                optionsData="id" />
                                        </td>
                                        <td>
                                            <az-input
                                                sizing="sm"
                                                placeholder="Ilimitadas"
                                                v-model="graph.samples" />
                                        </td>
                                        <td>
                                            <az-input
                                                sizing="sm"
                                                placeholder="Séries..."
                                                :validate="validate"
                                                v-model="graph.c_series" 
                                                type="select"
                                                optionsMode="json"
                                                :optionsList="lista_categorias" 
                                                optionsDisplay="search"
                                                optionsData="id" />
                                        </td>
                                        <td>
                                            <az-input
                                                sizing="sm"
                                                placeholder="Tamanho..."
                                                required
                                                :validate="validate"
                                                v-model="graph.size" 
                                                type="select"
                                                optionsMode="json"
                                                :optionsList="[
                                                    { id: '12', search: '1' },
                                                    { id: '9', search: '3/4' },
                                                    { id: '8', search: '2/3' },
                                                    { id: '6', search: '1/2' },
                                                    { id: '4', search: '1/3' },
                                                    { id: '3', search: '1/4' },
                                                ]" 
                                                optionsDisplay="search"
                                                optionsData="id" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div v-if="false">
                                <div class="row" v-for="(graph, igx) in dados.graphs" :key="'g' + igx">
                                    <div class="col col-12">
                                        
                                        {{ graph }}
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="card-footer">
                            <a class="btn btn-sm btn-outline-primary" href="#" @click.prevent="incluir_grafico()">
                                <i class="fas fa-plus"></i>
                            </a>    
                        </div>
                    </div>
                </div>

                <!-- Vinculo de Página... -->

                <div class="card">

                    <div class="card-header d-flex justify-content-between alert-primary">
                        <div>
                            <a class="card-link" data-toggle="collapse" href="#tela-card">
                                Disponbilizar em Telas do Sistema
                            </a>
                        </div>
                        <div>
                            <span class="badge badge-primary">
                                {{ dados.query_pages ? dados.query_pages.length : 0 }}
                            </span>
                        </div>
                    </div>

                    <div class="collapse show multi-collapse" id="tela-card">
                        <div class="card-body">
                            <div v-if="!dados.query_pages.length">No módulo de relatórios</div>

                            <div v-else>
                                <div v-for="(qp, iqx) in dados.query_pages" :key="iqx">
                                    <div class="form-row" v-if="qp.page_id != -1">
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                sizing="sm"
                                                type="select"
                                                :optionsList="pages"
                                                optionsDisplay="name"
                                                optionsData="id"
                                                v-model="qp.page_id">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="remover_page(qp)">
                                                            <i class="fa fa-minus" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card-footer">
                            <a class="btn btn-sm btn-outline-primary" href="#" @click.prevent="incluir_page()">
                                <i class="fas fa-plus"></i>
                            </a>    
                        </div>
                    </div>

                </div>

                <!-- Relatório para Apoiado... -->

                <div class="card" v-if="pode_apoiado">

                    <div class="card-header d-flex justify-content-between alert-primary">
                        <div>
                            <a class="card-link" data-toggle="collapse" href="#apoiado-card">
                                Disponbilizar no Portal do Apoiado
                            </a>
                        </div>
                        <div>
                            <i class="fa fa-check-circle text-success" aria-hidden="true" v-if="dados.to_apoiado"></i>
                            <i class="fa fa-times-circle text-danger" aria-hidden="true" v-else></i>
                        </div>
                    </div>

                    <div class="collapse show multi-collapse" id="apoiado-card">
                        <div class="card-body">
                            <az-input
                                type="checkbox-group"
                                label="Disponibilizar no Portal do Apoiado"
                                sizing="sm"
                                v-model="dados.to_apoiado" />
                        
                            <div class="mt-3" v-if="dados.to_apoiado">
                                <!-- Filtros -->
                                <filtro-model class="mt-3" v-model="dados.apoiado_filtros" :validate="validate" :delecao="false" :opcoes="lista_opcoes_filtro_apoiado" />
                            </div>
                        </div>

                        <div class="card-footer" v-if="false"> 
                            <a class="btn btn-sm btn-outline-primary" href="#" @click.prevent="incluir_page()">
                                <i class="fas fa-plus"></i>
                            </a>    
                        </div>
                    </div>

                </div>



            </template>

            <br><br><br>

            <template v-if="false">
                <hr>
                <pre class="alert alert-warning">{{ dados }}</pre>
                <pre class="alert alert-info">{{ meta }}</pre>
            </template>

            <edicao-acessos ref="acessos" v-if="dados.id" />

            <nav class="navbar fixed-bottom navbar-light bg-light" v-if="dados.meta">
                <span class="navbar-brand" href="#">
                    {{ dados.title }}
                </span>
                <div class="mr-3 mr-md-0">
                    <az-submit color="danger mr-2" @click="remover()" v-if="id">
                        Remover
                    </az-submit>
                    <az-submit @click="atualizar ()">
                        {{ id ? 'Atualizar' : 'Incluir' }}
                    </az-submit>
                </div>
            </nav>

        </template>

        <!-- Seleção de Lista -->
        <div class="modal fade" id="selecaoListaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="filtro_edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Lista:
                            {{ filtro_edicao.title }}
                            <span class="badge badge-secondary ml-2" v-if="1==0 && filtro_edicao.opcoes">
                                {{ filtro_edicao.opcoes.filter(item => item.selec).length }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="filtro_edicao.opcoes">
                            <div class="row" v-for="(opcao, iox) in filtro_edicao.opcoes" :key="iox">
                                <div class="col co-12">
                                    <az-input
                                        sizing="sm"
                                        type="checkbox-group"
                                        :label="opcao.search"
                                        v-model="opcao.selec" />
                                </div>
                            </div>
                        </template>

                        <pre v-if="false">{{ filtro_edicao }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="button" class="btn btn-success" @click="selecionar_lista_opcoes()">Selecionar</button>
                    </div>
                </div>
            </div>
        </div>

        <relatorio-editor-lista-selecao ref="lista_selecao" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../cadastros/shared/ConfigMainTitle.vue';
import AzInput from '../shared/forms/AzInput.vue';
import draggable from "vuedraggable";
import AzSubmit from '../util/AzSubmit.vue';
import AzEmptyState from '../util/AzEmptyState.vue';
import EdicaoAcessos from '../cadastros/shared/EdicaoAcessos.vue';
import FiltroModel from '../cadastros/shared/FiltroModel.vue';
import RelatorioEditorListaSelecao from './RelatorioEditorListaSelecao.vue';

export default {
    data() { 
        return { 
            dados: { 
                meta: "",
                cols: [],
                filtros: [], 
                title: "",  
                descr: "", 
                graphs: [], 
                comps: [], 
                ordem: [], 
                query_group_id: 1,
                acesso: "M",
                pivot: false, 
                query_pages: [], 
                to_apoiado: false, 
            }, 
            novocampo: "", 
            novofiltro: "", 
            novaordem: "", 
            meta: [], 
            validate: false, 
            drag: false, 
            carregando: true, 
            groups: [], 
            acesso_disponivel: true, 
            listas: null, 
            trocando_tipo: null, 
            filtro_edicao: null, 
            pages: [], 
            relatorios: [], 
            tem_apoiados: false, 
            pode_apoiado: false, 
        }
    },

    components: { 
        ConfigMainTitle,
        AzInput, 
        draggable, 
        AzSubmit, 
        AzEmptyState, 
        EdicaoAcessos, 
        FiltroModel,
        RelatorioEditorListaSelecao,
    },

    props: ['id'],

    computed: { 
        lista_opcoes_filtro_apoiado: function () {
            return [
                {id:'App\\azure\\apoiado', search:'Apoiado', service: 'apoiados.index'}, 
                // {id:'App\\azure\\apoiadoOrigem', search:'Apoiado - Origem', service:'apoiado_origens.index', parms: { lista_filtro: true }},
                {id:'tag-apoiado', search:'Classificação da Apoiado', service: 'apoiados.index', tag: true},
            ];
        },

        comp_filtros: function () { 
            if ( !this.dados || !this.dados.filtros ) 
                return [];

            return _.uniqBy(
                this.dados.filtros.filter(item => item.tipo != 'F' && item.tipo != 'U')
                    .map((item, key) => { 

                        let chave = ( item.value == 'timestamp' ? ':periodo' : ':parm' ) + key;

                        return { 
                            id: item.name, 
                            search: item.name,  
                            chave: chave
                        }
                    }),
                'id'
            );
        },
        tem_agregacao: function () { 
            if ( !this.dados || !this.dados.cols ) 
                return false;

            if ( this.dados.cols.length == 3 && this.dados.pivot )
                return false;

            return this.dados.cols.find(item => item.action == 'C' || item.action == 'D' || item.action == 'S' || item.action == 'M') ? true : false;
        },

        lista_campos: function () { 
            if ( !_.get(this.dados, 'meta.config.cols') ) { 
                return [];
            }

            let lista = this.dados.meta.config.cols;

            lista = lista.concat(this.dados.cols.filter(item =>item.formula && item.title));

            return _.orderBy(lista, (item) => item.title ? item.title.toUpperCase() : '?');
        },

        lista_variaveis: function () { 
            return this.dados.cols.filter(item => item.value == 'computed' || ( item.value == 'value' || ( item.action && item.action != 'L' && item.action != 'Q' ) ) )
                .map(item => { 
                    return { 
                        id: item.name,
                        search: item.title ? item.title : '[' + item.name + ']', 
                    };
                });
        },

        lista_categorias: function () { 
            return this.dados.cols.filter(item => item.value != 'value' && item.action && ( item.action == 'L' || item.action == 'Q' ))
                .map(item => { 
                    return { 
                        id: item.name,
                        search: item.title, 
                    };
                });
        },
    },

    methods: { 
        callback_campo (item) { 
            this.novocampo = item;
        },

        callback_filtro (item) { 
            this.novofiltro = item;
        },

        abrir_lista_selecao(lista, callback = null, cardname = null) { 
            if ( cardname && this.$refs[cardname] ) { 
                
                const el = this.$refs[cardname];
                const offset = 100; // distância do topo em px

                const y = el.getBoundingClientRect().top + window.pageYOffset - offset;

                window.scrollTo({
                    top: y,
                    behavior: 'smooth'
                });
                
            }

            this.$refs.lista_selecao.abrir(lista, callback);
        }, 

        tem_parametro_campo (campo, teste = null) { 
            if ( !campo || !campo.sql ) { 
                return false; 
            }

            if ( teste ) { 
                return campo.sql.includes(teste);
            }

            if ( campo.sql.includes('(?)') || campo.sql.includes('[?]') ) { 
                return true;
            }

            return false; 
        },

        get_service (filtro) { 
            if ( filtro.service && filtro.format == 'list-tags' ) 
                return filtro.service.replace('.index', '.tags');
            
            if ( filtro.service ) 
                return filtro.service;

            return ''; 
        },

        incluir_comp () { 

            this.dados.comps.push({ 
                query_id: "", 
                type: "",
                obs: "", 
                fills: [], 
                links: [], 
                parms: [], 
            });

        },

        incluir_parm (comp) { 
            if ( !comp.parms ) 
                comp.parms = [];

            comp.parms.push({ 
                de: "", 
                para: "", 
            });
        },

        incluir_fill (comp) { 
            if ( !comp.fills ) 
                comp.fills = [];

            comp.fills.push({ 
                campo: "", 
                fonte: "", 
                oper: "S",
            });
        },

        incluir_link (comp) { 
            if ( !comp.links ) 
                comp.links = [];

            comp.links.push({ 
                de: "", 
                para: "", 
                oper: "=",
            });
        },  

        sel_query_campos (id) { 
            let rel = this.sel_query(id);

            if ( !rel || !rel.config || !rel.config.cols ) 
                return [];

            return rel.config.cols;
        },

        sel_query_title (id) { 
            let rel = this.sel_query(id);

            if ( !rel || !rel.title ) 
                return id + '?';

            return rel.title;
        },

        sel_query_parms (id) { 
            let rel = this.sel_query(id);

            if ( !rel || !rel.config || !rel.config.parms ) 
                return [];

            return rel.config.parms;
        },

        sel_query (id) { 
            let rel = this.relatorios.find(item => item.id == id);
            return rel;
        },

        editar_relatorio (id) { 
            this.$router.push({ path: '/relatorio/editor/' + id });

            this.$nextTick(() => { 
                this.load();
            });
        },

        toggle_hide (campo) { 
            campo.hide = !campo.hide;
            this.$forceUpdate();
        },

        remover_page(item) { 
            item.page_id = -1;
        },

        incluir_page () { 
            this.dados.query_pages.push({ page_id: "" });
        },

        lista_tipo_filtro(filtro) { 
            let lista = [
                {id: 'F', search: 'Fixo'},
                {id: 'U', search: 'Fixo Usuário Logado'},
                {id: 'P', search: 'Parâmetro'},
                {id: 'O', search: 'Parâmetro Obrigatório'},
            ];

            if ( filtro && filtro.format == 'list-system' && filtro.service == 'medicos.index' ) { 
                lista = [
                    {id: 'F', search: 'Fixo'},
                    {id: 'M', search: 'Fixo Médico Logado'},
                    {id: 'U', search: 'Fixo Usuário Logado'},
                    {id: 'P', search: 'Parâmetro'},
                    {id: 'O', search: 'Parâmetro Obrigatório'},
                ];
            }

            if ( filtro && filtro.format == 'list-system' && filtro.service == 'apoiados.index' ) { 
                lista = [
                    {id: 'F', search: 'Fixo'},
                    {id: 'A', search: 'Fixo Apoiado Logado'},
                    {id: 'U', search: 'Fixo Usuário Logado'},
                    {id: 'P', search: 'Parâmetro'},
                    {id: 'O', search: 'Parâmetro Obrigatório'},
                ];
            }

            return lista;
        },

        filtro_agregado(filtro) { 
            return this.dados.cols.find(item => item.name == filtro.name && item.action && item.action != 'L') ? true : false;
        },

        service_key (service) {
            switch (service) {
                case 'apoiados.index': return 'id_apoiado';
                case 'tarefa_grupos.index': return 'id_tarefa_grupo';
                case 'especialidades.index': return 'id_especialidade';
                case 'operadoras.index': return 'id_operadora';
                case 'medicos.index': return 'id_pessoa';
                case 'planos.index': return 'id_plano';
                case 'procedimentos.index': return 'id_procedimento';
                case 'recepcaos.index': return 'id_recepcao';
                case 'unidade_operacaos.index': return 'id_unidade_operacao';
                case 'medico_solicitantes.index': return 'id_medico_solicitante';
                case 'estoque_grupos.index': return 'id_estoque_grupo';
                case 'procedimento_grupos.index': return 'id_procedimento_grupo';
                default: return 'id';
            }
        },

        service_parms (service) {
            switch (service) {
                case 'recepcaos.index': return { filtros: 1 };
                default: return {};
            }
        },

        selecionar_lista_opcoes () { 
            this.dados.filtros[this.filtro_edicao.index].valor = this.filtro_edicao.opcoes.filter(item => item.selec)
                .map(item => item[this.filtro_edicao.data])
                .join(',');

            this.$forceUpdate();

            $('#selecaoListaModal').modal('hide');
        },

        toggle_lista(filtro, index) { 
            this.trocando_tipo = index;

            let lista = filtro.valor ? filtro.valor.split(',') : [];
            let selecteds = {};

            lista.forEach(element => {
                selecteds[element] = true;
            });

            this.$nextTick(() => { 
                if ( filtro.list && filtro.valor ) { 
                    //
                } else { 
                    filtro.list = !filtro.list; 
                }
                
                this.$forceUpdate();

                this.trocando_tipo = null;

                if ( filtro.list && filtro.dd ) { 
                    let service = filtro.service.split('.');

                    this.filtro_edicao = _.cloneDeep(filtro);
                    this.filtro_edicao.opcoes = [];
                    this.filtro_edicao.index = index;

                    this.$util.loadItem(this, { 
                        service: service[0],
                        func: service[1],
                        parms: { 
                            ativos: true, 
                            agenda: true,
                            ...this.service_parms(filtro.service),
                        }
                    })
                    .then(res => { 
                        this.filtro_edicao.opcoes = _.orderBy(
                            res.map(item => { 
                                item.selec = selecteds[item[this.filtro_edicao.data]] ? true : false;
                                return item;
                            }),
                            'search'
                        );
                    })
                    .finally(() => { 
                        $('#selecaoListaModal').modal('show');
                        this.$forceUpdate();
                    });
                } 
            });
        },

        toggle_select_type(filtro, index) { 
            this.trocando_tipo = index;

            this.$nextTick(() => { 
                filtro.dd = !filtro.dd; 
                this.$forceUpdate();

                this.trocando_tipo = null;
            });
        },

        download () { 
            $('[data-toggle="tooltip"]').tooltip('hide');
            
            var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(this.dados));
            var downloadAnchorNode = document.createElement('a');
            downloadAnchorNode.setAttribute("href",     dataStr);
            downloadAnchorNode.setAttribute("download", "relatorio.json");
            document.body.appendChild(downloadAnchorNode); 
            downloadAnchorNode.click();
            downloadAnchorNode.remove();
        },

        upload() { 
            $('[data-toggle="tooltip"]').tooltip('hide');

            var downloadAnchorNode = document.createElement('input');
            downloadAnchorNode.setAttribute("type", "file");
            downloadAnchorNode.setAttribute("class", "d-none");
            downloadAnchorNode.onchange = () => { this.posUpload(downloadAnchorNode); };
            document.body.appendChild(downloadAnchorNode); 
            downloadAnchorNode.click();
        },

        posUpload(el) { 
            var file = el.files[0];

            if (file) {

                var reader = new FileReader();
                
                reader.readAsText(file, "UTF-8");
                
                reader.onload = (evt) => {
                    let info = JSON.parse(evt.target.result); 

                    if ( !info.meta ) { 
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: "Arquivo inválido. Não é um relatório da área selecionada.",
                            life: 3000
                        });

                        return;
                    } else if ( info.meta.id != this.dados.meta.id ) { 
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: "Arquivo inválido. Não é um relatório da área selecionada: " + info.meta.name + ". (" + info.meta.id + "x" + this.dados.meta.id + ")",
                            life: 3000
                        });

                        return;
                    }

                    info.id = this.dados.id; 
                    info.title = this.dados.title ? this.dados.title : info.title;
                    info.meta = this.dados.meta;
                    info.descr = this.dados.descr ? this.dados.descr : info.descr;

                    this.dados = _.cloneDeep(info);

                    this.$toast.add({
                        severity: "success",
                        summary: "Atenção",
                        detail: "Arquivo carregado.",
                        life: 3000
                    });

                }

                reader.onerror = function () {
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Falha lendo arquivo.",
                        life: 3000
                    });
                }

            }

        },

        acessos() { 
            this.$refs.acessos.abrir('App\\Query', this.dados.id);
        },
        
        remover () { 
            if ( !confirm('Confirma remover esse relatório da base?') )
                return;

            this.$util.atualizar(this, { 
                service: 'relatorios',
                func: 'remover_meta',
                dados: { 
                    id: this.id 
                },
                toast: true, 
                callback: () => { 
                    this.$router.push({ path: '/relatorios' });
                }
            });
        },

        tratar_opcoes (lista, campo) { 
            if ( this.listas && _.get(this.listas, campo.name) ) { 
                lista = _.get(this.listas, campo.name);
            }

            return _.map(lista, (item, chave) => { 
                if ( item.data && item.display ) { 
                    return { 
                        id: item.data,
                        search: item.display,
                    };
                }

                return { 
                    id: chave,
                    search: item
                };
            });
        },

        removerOrdem (idx) { 
            this.dados.ordem.splice(idx,1);
        },

        incluir_ordem () { 

            if ( !this.novaordem ) 
                return;

            if ( !this.dados.ordem )
                this.dados.ordem = [];

            let indice = this.dados.cols.findIndex(item => item.column_name == this.novaordem.column_name);

            this.dados.ordem.push({ 
                index: indice,
                direc: 'ASC',
            });

            this.$nextTick(() => { 
                this.novaordem = "";
            });

        },

        incluir_grafico () { 

            this.dados.graphs.push({ 
                title: "", 
                type: "bar",
                var: "",
                category: "", 
                ordem: "value",
                samples: "", 
                series: "", 
                size: "6",
            });

        },

        atualizar () { 
            if ( this.dados.cols.length != 3 ) { 
                this.dados.pivot = false;
            }

            if ( this.dados.cols.filter(item => item.action == 'P').length > 1 ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Não é possível incluir mais de um campo de Pivot.",
                    life: 3000
                });

                return;
            }

            if ( this.dados.cols.filter(item => item.action == 'P').length > 0 
                && this.dados.cols.filter(item => item.value == 'value' 
                    || item.action == 'C'
                    || item.action == 'D'
                    || item.action == 'S'
                    || item.action == 'M').length > 1 ) { 

                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Não é possível incluir mais de um campo de valor com coluna pivot.",
                    life: 3000
                });

                return;

            }    

            this.$util.atualizar(this, { 
                service: 'relatorios',
                func: 'salvar_meta',
                dados: this.dados,
                toast: true, 
                callback: res => { 
                    this.validate = false;

                    if ( !this.id && res.id ) { 
                        this.$router.push({ path: '/relatorio/editor/' + res.id });

                        this.$nextTick(() => { 
                            this.load();
                        });
                    }
                }
            });
        },

        removerColuna (idx) { 
            this.dados.cols.splice(idx,1);
        },

        removerGrafico (idx) { 
            this.dados.graphs.splice(idx,1);
        },

        removerFiltro (idx) { 
            this.dados.filtros.splice(idx,1);
        },

        removerComp (idx) { 
            this.dados.comps.splice(idx,1);
        },

        incluir_filtro () { 
            if ( !this.novofiltro )
                return;

            this.dados.filtros.push({
                ...this.novofiltro,
                tipo: "P", 
                operacao: "=",
                valor: "", 
                data: this.service_key(this.novofiltro.service),
            });

            this.$nextTick(() => { 
                this.novofiltro = "";
            });
        },

        incluir_campo (formula = false) { 
            let info;

            if ( formula ) { 
                info = { 
                    name: 'form.' + ( '.' + Math.random() ).slice(4,10),
                    formula: true, 
                    compute: '',
                    value: 'computed',
                    title: '',
                };
            } else if ( !this.novocampo ) { 
                return;
            } else { 
                info = this.novocampo;
            }

            this.dados.cols.push({
                ...info,
                action: "L", 
                column_name: 'col.' + ( '.' + Math.random() ).slice(4), 
            });

            this.$nextTick(() => { 
                this.novocampo = "";
            });
        },

        load () { 

            this.validate = false;

            this.$store.commit("loading", true);

            let query = {
                q: [
                    {
                        name: 'relatorios.meta',
                        id: "meta",
                        parms: { 
                            id: this.id, 
                        }
                    }
                ]
            };

            this.axios
                .post("/aql?a=relatorios.editor", query)
                .then(res => {
                    if (res.data.meta.status == 200) {

                        if ( this.id ) { 

                            this.pode_apoiado = res.data.meta.data.tem_apoiados;

                            this.groups = res.data.meta.data.groups;

                            this.dados.meta = res.data.meta.data.meta;
                            this.listas = res.data.meta.data.listas;

                            this.dados.id = res.data.meta.data.query.id;
                            this.dados.title = res.data.meta.data.query.title;
                            this.dados.descr = res.data.meta.data.query.config.descr;
                            this.dados.cols = res.data.meta.data.query.config.columns;
                            this.dados.query_group_id = res.data.meta.data.query.query_group_id;
                            this.dados.graphs = res.data.meta.data.query.config.graphs 
                                ? res.data.meta.data.query.config.graphs : [];

                            this.dados.comps = res.data.meta.data.query.config.comps 
                                ? res.data.meta.data.query.config.comps : [];

                            this.dados.filtros = res.data.meta.data.query.config.filtros 
                                ? res.data.meta.data.query.config.filtros : [];

                            this.dados.ordem = res.data.meta.data.query.config.ordem 
                                ? res.data.meta.data.query.config.ordem : [];

                            this.dados.pivot = res.data.meta.data.query.config.pivot ? true : false;
                            this.dados.query_pages = res.data.meta.data.query.query_pages;
                            this.dados.apoiado_filtros = res.data.meta.data.query.apoiado_filtros;

                            this.dados.to_apoiado = res.data.meta.data.query.config.to_apoiado 
                                ? res.data.meta.data.query.config.to_apoiado : false;

                            this.dados.apoiado_filtros = res.data.meta.data.query.apoiado_filtros 
                                ? res.data.meta.data.query.apoiado_filtros : [];

                        } else { 
                            this.meta = res.data.meta.data.metas;
                            this.groups = res.data.meta.data.groups;
                        }

                        this.pages = res.data.meta.data.pages;
                        this.tem_apoiados = res.data.meta.data.tem_apoiados;

                        let breadcrumb; 

                        if ( !this.breadcrumb ) { 
                            breadcrumb = [
                              { name: "Relatórios", path: "/relatorios" }
                            ];

                            if ( this.id ) { 

                                breadcrumb.push({
                                    name: this.dados.title,
                                    path: "/relatorio/" + this.id
                                });

                            }

                        } else { 

                            breadcrumb = _.cloneDeep(this.breadcrumb);

                        }

                        breadcrumb.push({
                                name: 'Configuração',
                                path: "/relatorio/editor/" + this.id
                            });

                        this.$store.commit("setBreadcrumb", breadcrumb);

                    } else { 

                        this.acesso_disponivel = false; 
                        
                    }
                })
                .finally(() => {
                    this.carregando = false; 
                    this.$store.commit("loading", false);
                });

        },

        carregar_relatorios () { 
            this.$util.loadItem(this, { 
                    service: 'relatorios',
                    func: 'index',
                    parms: { 
                        config_dash: true, 
                        ordem: 'alfa',
                    }
                })
                .then(res => { 
                    this.relatorios = res;
                });
        }
    },

    mounted() { 
        this.carregar_relatorios(); 
        this.load();
    }
}
</script>